import { lazy } from "react";

const CreateRatingQuestionPage = lazy(() => import("./create"));
const RatingQuestionListPage = lazy(() => import("./main"));
const UpdateRatingQuestionPage = lazy(() => import("./update"));

export {
  CreateRatingQuestionPage, RatingQuestionListPage, UpdateRatingQuestionPage,
};
